import { Controller } from "@hotwired/stimulus"

// The server marks the one block the operator's edit was about, and renders it
// open: the block opts out of the disclosure's sessionStorage restoration, so
// there is nothing left here to fight and nothing to click. One frame is still
// needed before measuring — the panel has not laid out at connect().
export default class extends Controller {
  connect() {
    requestAnimationFrame(() => this.reveal())
  }

  // A re-run can replace the frame between connect() and the next frame, and
  // measuring a detached element scrolls the panel to a meaningless offset.
  reveal() {
    if (!this.element.isConnected) return

    this.scrollIntoPanel()
  }

  // The panel scrolls inside its own tab body; scrollIntoView would walk every
  // scrollable ancestor and drag the editor page along with it.
  scrollIntoPanel() {
    const container = this.scrollContainer()
    if (!container) return

    const delta =
      this.element.getBoundingClientRect().top - container.getBoundingClientRect().top
    container.scrollTo({ top: container.scrollTop + delta - 8, behavior: this.behavior })
  }

  get behavior() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
  }

  scrollContainer() {
    let node = this.element.parentElement
    while (node && node !== document.body) {
      const overflowY = getComputedStyle(node).overflowY
      if ((overflowY === "auto" || overflowY === "scroll") && node.scrollHeight > node.clientHeight) {
        return node
      }
      node = node.parentElement
    }
    return null
  }
}
